/**
 * SHA-256 hash utility using the Web Crypto API.
 * Works in both Cloudflare Workers and browsers.
 */
export async function sha256(data) {
    const encoder = new TextEncoder();
    const buffer = await crypto.subtle.digest('SHA-256', encoder.encode(data));
    return Array.from(new Uint8Array(buffer))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}
/** Well-known genesis hash for the first entry in the audit chain */
export const GENESIS_SEED = 'AIGFTPWATCH_GENESIS';
/** Compute the genesis hash */
export async function genesisHash() {
    return sha256(GENESIS_SEED);
}
/**
 * Compute an audit log entry hash.
 * entry_hash = SHA-256(prev_hash | entity_type | entity_id | action | timestamp | user_email | new_data)
 */
export async function computeEntryHash(prevHash, entityType, entityId, action, timestamp, userEmail, newData) {
    const payload = [prevHash, entityType, String(entityId), action, timestamp, userEmail, newData ?? ''].join('|');
    return sha256(payload);
}
/**
 * Compute a Merkle tree internal node hash.
 * hash = SHA-256(left_hash | right_hash)
 */
export async function computeNodeHash(leftHash, rightHash) {
    return sha256(leftHash + '|' + rightHash);
}
/**
 * Verify a Merkle inclusion proof client-side.
 * Returns true if the proof is valid against the given root hash.
 */
export async function verifyMerkleProof(entryHash, proof, rootHash) {
    let currentHash = entryHash;
    for (const step of proof) {
        if (step.direction === 'left') {
            currentHash = await computeNodeHash(step.hash, currentHash);
        }
        else {
            currentHash = await computeNodeHash(currentHash, step.hash);
        }
    }
    return currentHash === rootHash;
}
//# sourceMappingURL=hash.js.map